module.exports = function(PluginManager) {
  PluginManager.registerViewProvider(require('./providers/url'));
  PluginManager.registerViewMatcher('url', require('./matchers/url'));
};
